import { ActionBar } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../translations';

type NfzPasswordChangeCancelActionProps = {
   onClick: VoidFunction;
};

export const NfzPasswordChangeCancelAction = (props: NfzPasswordChangeCancelActionProps): JSX.Element => {
   return (
      <ActionBar.PrimaryLink
         testId={'passwordChangeCancel'}
         label={nfzLoginTranslationKeys.cancelChangePassword}
         onClick={props.onClick}
      />
   );
};
